import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { YearPortion, Year } from '../../../models';
import { RmsUtilsService } from '../../../../core/services';
import { EventsHubService } from '../../../../core/events-hub.service';


/**
 * Component Class for quarter picker date element selections
 */
@Component({
    selector: 'rms-quarter-picker-date',
    templateUrl: './quarter-picker-date.component.html',
    styleUrls: ['./quarter-picker-date.component.scss'],
    standalone: false
})
export class QuarterPickerDateComponent implements OnInit, AfterContentInit {

  @Input() yearsList: Array<Year> = [];
  @Input() initialValue: string;
  @Output() onQuarterSelected = new EventEmitter<YearPortion>();
  @Output() yearSelected = new EventEmitter<Year>();
  public yearsListSet: Array<Year> = [];
  public quarterList: Array<YearPortion> = [
    {selected: false, name: '1Q'},
    {selected: false, name: '2Q'},
    {selected: false, name: '3Q'},
    {selected: false, name: '4Q'}
  ];

  constructor(private eventsHubService: EventsHubService) { }

  ngOnInit() {
    this.yearsListSet = this.yearsList.map(item => Object.assign({}, item));
    this.eventsHubService.resetQuarterPicker$.subscribe(
      () => {
        RmsUtilsService.resetSelected(this.quarterList);
        RmsUtilsService.resetSelected(this.yearsListSet);
      }
    );
  }

  ngAfterContentInit () {
    if (this.initialValue) {
      if (this.initialValue.length <= 4) {
        const selected = this.quarterList.find(item => item.name === this.initialValue.substring(0, 2)).name;
        this.selectQuarter(this.quarterList.find(item => item.name === selected));
      } else {
        const selectedValue = this.initialValue.split(' ');
        const selected = this.quarterList.find(item => item.value === selectedValue[0]).value;
        this.selectQuarter(this.quarterList.find(item => item.value === selected));
      }
    }
  }

  /**
   * Detects quarter item selection and emits the selected data to the parent component
   * @param {YearPortion} item: item to emit
   */
  public selectQuarter (item: YearPortion) {
    RmsUtilsService.resetSelected(this.quarterList);
    item.selected = true;
    this.onQuarterSelected.emit(item);
  }

  /**
   * Detects year selection and passes it to the parent component
   * @param evt
   */
  public onYearSelected (evt: Year): void {
    this.yearSelected.emit(evt);
  }

}
